import Container from '@anm/components/Container';
import isMobile from '@anm/helpers/is/isMobile';
import useIsMountedCheck from '@anm/hooks/useIsMountedCheck';
import React, { FC } from 'react';

import { CommonLandingProps } from '../../../features/getLanding';
import Background, { BackgroundVariants } from '../../Background';
import LandingButton, { LandingButtonProps } from '../../LandingButton';
import { SectionTitleProps } from '../../SectionTitle';

import List from './List';
import { MediaProps } from './Media';
import MediaBlock from './MediaBlock';
import SideMediaButtonsWrapper from './SideMediaButtonsWrapper';
import SideMediaContentWrapper from './SideMediaContentWrapper';
import { SideMediaDataWrapper, SideMediaDescription, SideMediaTitle } from './SideMediaDataWrapper';
import SectionWrapper from './Wrapper';
import { ListProps } from './types';

export type TextVariant = 'medium' | 'big';

export type SideMediaLinkListProps = CommonLandingProps &
  SectionTitleProps &
  MediaProps &
  ListProps & {
    sectionWidth?: number;
    dataMaxWidth?: number;
    imageSideMediaUrl?: string;
    button?: LandingButtonProps;
    textVariant?: TextVariant;
    isTitleExtraBold?: boolean;
    isVideoOnMobileUnderTitle?: boolean;
    backgroundVariant?: BackgroundVariants;
  };

const SideMediaLinkList: FC<SideMediaLinkListProps> = ({
  list,
  title,
  button,
  sideMedia,
  imageSideMediaUrl,
  mediaFrame,
  description,
  sectionWidth,
  playIconSize,
  headingLevel,
  dataMaxWidth,
  mediaMaxWidth,
  customBackground,
  isTitleExtraBold,
  backgroundVariant,
  textVariant = 'medium',
  isVideoOnMobileUnderTitle
}) => {
  const showDesktopMedia = !(isMobile() && isVideoOnMobileUnderTitle) || !isMobile();
  const showMobileMedia = useIsMountedCheck() && isMobile() && isVideoOnMobileUnderTitle;

  const mediaProps = {
    title,
    sideMedia,
    mediaFrame,
    playIconSize,
    mediaMaxWidth,
    imageSideMediaUrl
  };

  return (
    <SectionWrapper>
      <Background variant={backgroundVariant || 'with-smaller-bottom-wave'} customBackground={customBackground}>
        <Container size={sectionWidth || 1180}>
          <SideMediaContentWrapper>
            <SideMediaDataWrapper {...{ dataMaxWidth }}>
              <SideMediaTitle
                {...{
                  title,
                  textVariant,
                  isTitleExtraBold
                }}
                color="black"
                level={headingLevel}
              />
              {showMobileMedia && <MediaBlock {...mediaProps} />}
              {list && <List {...{ list }} />}
              <SideMediaButtonsWrapper>
                <LandingButton size="big" variant="light-blue-lowercase" {...button} />
              </SideMediaButtonsWrapper>
            </SideMediaDataWrapper>
            <div>
              {showDesktopMedia && <MediaBlock {...mediaProps} />}
              <SideMediaDescription {...{ textVariant, description }} color="black" />
            </div>
          </SideMediaContentWrapper>
        </Container>
      </Background>
    </SectionWrapper>
  );
};

export default SideMediaLinkList;
